import request from '@/util/request'

// 代表队详情
export function getTeamInfo(competitionId) {
  return request({
    url:  `/api/register/team/info/${competitionId}`,
    method: 'GET',
  })
}

// 保存代表队信息
export const saveTeamInfo = (data) => {
  return request({
    url: `/api/register/team/save`,
    method: 'POST',
    data
  })
}

// 会员单位列表（仅启用）
export const getMemberUnitList = (data) => {
  return request({
    url: `/api/register/team/memberUnitList`,
    method: 'GET',
    data
  })
}

// 地区列表（仅启用）
export const getRegionList = (data) => {
  return request({
    url: `/api/register/team/regionList`,
    method: 'GET',
    data
  })
}

// 代表队列表
export const getTeamList = (data) => {
  return request({
    url: `/api/register/team/list`,
    method: 'GET',
    data
  })
}

// 代表队信息导出（全赛事）
export const getTeamExport = (data) => {
  return request({
    url: `/api/register/team/export`,
    method: 'GET',
    data,
    responseType: 'blob'
  })
}

// 提交报名
export const submitTeamInfo = (data) => {
  return request({
    url: `/api/register/team/submit`,
    method: 'POST',
    data
  })
}

// 取消提交
export const cancelSubmitTeamInfo = (data) => {
  return request({
    url: `/api/register/team/cancelSubmit`,
    method: 'POST',
    data
  })
}


// 提交报名（管理员代为提交）
export const managerSubmitTeamInfo = (data) => {
  return request({
    url: `/api/register/team/managerSubmit`,
    method: 'POST',
    data
  })
}

// 删除代表队（管理员，级联删除运动员、报项、随队官员）
export const managerDelTeamInfo = (data) => {
  return request({
    url: `/api/register/team/managerDel`,
    method: 'POST',
    data
  })
}
